import { useEffect, useState } from 'react';
import './index.scss';
import util from '../../utils/util';
import EventBus from '../../utils/EventBus';
import cartMaganer from '../../manager/cart';
import View from '../Base/View';
import { Image } from 'antd';
import Text from '../Base/Text';

const CartFloat = () => {

    const [cartTotalCount, setCardTotalCount] = useState<number>(0);

    /**
     * 获取购物车
     */
    const loadCartInfo = () => {
        cartMaganer.getCartList(false, function (success: boolean, res: any, tips: string) {
            console.log("loadCartInfo", res, tips)
            if (success) {
                setCardTotalCount(res.Items.length)
            }
        })
    }

    useEffect(() => {
        // 注册购物车变更监听
        const cartChangListener = function (listInfo: any) {
            var newCount = listInfo.Items.length
            setCardTotalCount(newCount)
        };
        EventBus.register(EventBus.names.CART_CHANGE, cartChangListener)
        loadCartInfo();
        return () => {
            EventBus.unregister(EventBus.names.CART_CHANGE, cartChangListener)
        }
    }, [])

    return <View className="cart-count-float" onClick={() => {
        util.navigateTo("/onlycart?isrmmp=1&hidemenu=1")
    }}>
        <Image
            className={
                'icon'
            }
            preview={false}
            src={require('../../images/nav_cart.png')}
        ></Image>
        {cartTotalCount > 0 && (
            <Text
                className={
                    'count'
                }
            >
                {cartTotalCount}
            </Text>
        )}
    </View>
}

export default CartFloat;